  <div [ngClass]="{'hidden' : !isComponentVisible}">
  <!-- Loading GIF Panel -->
  <div #loadingDiv class="loadingDiv" *ngIf="isInitialPageLoad">
    <img src="/assets/images/Forensic_Notes_Logo.png" 
      class="loadingLogo"tooltip="Loading Forensic Notes" />
    <img src="/assets/images/loading-gif-png-5.gif" 
      class="loadingAppGif"
    tooltip="Loading Forensic Notes" />
  </div>

<div class="center"  [ngClass]="{'hidden' : isInitialPageLoad}">
  <div class="st-head">
    <div class="st-head-copy">
      <div class="st-eyebrow">Organization</div>
      <h1 class="st-h1">Branding</h1>
      <p class="st-lead">Customize the cover page and disclaimer that appear on every notebook PDF your organization
        prints.</p>
    </div>
  </div>

  <div class="st-note instruction">
    <mat-icon>touch_app</mat-icon>
    <span>Click the <b>banner or logo</b> at the top, or the <b>disclaimer</b> at the bottom, to edit them. Everything
      else on this page is a preview and is not editable here.</span>
  </div>

  <section class="st-panel bd-preview-panel">
    <div class="st-panel-head">
      <mat-icon>picture_as_pdf</mat-icon>
      <h2 class="st-h2">Cover page preview</h2>
    </div>
    <p class="st-hint smallgrey">A rough example of the final cover page — print an actual notebook PDF to see the
      finished product.</p>
  <div class="pdf-main">
    <div  title="Click to Customize Banner/Header Area">
      <div *ngIf="showbanner" class="hand banner" (click)="openOrgDialog($event)">
        <!-- <div class="instruct" (click)="openOrgDialog($event)"> -->
        <img src="{{ updateBrand.bannerPath }}" class="PDFBannerImage" />
        <!-- </div> -->
      </div>
      <div *ngIf="showLogo" class="hand" (click)="openOrgDialog($event)">
        <img src="{{ updateBrand.logoPath }}" class="PDFLogoImage" />
        <div class="orgName">{{ updateBrand.organizationName }}</div>
      </div>
     
    </div>
    <div>
      <div (click)="ejDialogNotebookName.show()" class="notebook-name help" title="Click to view more information">
        <div>Name Of Notebook</div>
      </div>
      <div (click)="ejDialogOwnerName.show()" class="name-of-current help" title="Click to view more information">
        <div class="cnNotesHeading">Contemporaneous Notes of</div>
        <div class="cnDisplayName">{{ appComponent.user.displayName }}</div>
      </div>
      <div (click)="ejDialogDates.show()" class="date-of-current help" title="Click to view more information">
        <p>
          <b>{{ fromdate }}</b>
          <br />
          to
          <br />
          <b>{{ todate }}</b>
        </p>
      </div>
      <div (click)="ejDialogTimeZone.show()" class="current-timezone hand" title="Click to view more information">All Times Displayed are in: {{ appComponent.user.timeZone }}</div>
      <div>
     <editor *ngIf="tinyThemeVisible" #disclaimerTiny [(ngModel)]="updateBrand.notebookDisclaimer"
      [init]="{
     base_url: '/tinymce',
     skin: themeService.isDark ? 'oxide-dark' : 'oxide',
     content_css: themeService.isDark ? 'dark' : 'default',
     suffix: '.min',
     paste_data_images: true,
     paste_as_text: true,
     imagetools_cors_hosts: ['picsum.photos'],
     paste_webkit_styles: 'all',
    menubar: '',
     toolbar: [
      'undo redo | bold forecolor | numlist bullist table | align'
     ],
     plugins: [
       'paste importcss image table charmap hr advlist lists wordcount imagetools textpattern quickbars'
     ],
     textpattern_patterns: [
    {start: '*', end: '*', format: 'italic'},
    {start: '**', end: '**', format: 'bold'},
  ],
    toolbar_sticky: false,
    image_advtab: true,
  height: 400,
  image_caption: true,
  quickbars_selection_toolbar: 'bold italic | h2 h3 blockquote | quickimage | inserttable',
  quickbars_insert_toolbar: 'quickimage quicktable | charmap hr | insertdatetime',
  toolbar_mode: 'floating',
  contextmenu: 'image imagetools table inserttable insertdatetime quickimage',
  content_style: [
    'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }' + 
    'img {max-width: 100%;}'
    ]
   
   }"></editor>
      </div>
    </div>
    
  </div>
  <!-- (end of) Page outline -->
  <div class="st-actions st-actions--right">
    <button type="button" class="st-btn st-btn--primary" (click)="updateNotice()">
      <mat-icon>save</mat-icon>Update disclaimer / info section
    </button>
  </div>
  </section>
  </div>


  <div #containerOrg class="root-container">
    <ejs-dialog id="dialog" #ejDialogOrganization isModal="true" (overlayClick)="onOverlayClick()" showCloseIcon="true"
      cssClass="fn-dialog fn-settings-form" header="Organization Information" width="600px" [visible]="false">

      <div class="st-field">
        <label class="st-label" for="org_name">Organization name</label>
        <input #org_name id="org_name" class="st-input" placeholder="Enter organization name..." minlength="1"
          maxlength="30" [(ngModel)]="updateBrand.organizationName" />
      </div>

      <div class="organise">
        <h3 class="st-h3">Square logo</h3>
        <p class="st-hint">Square logo placed next to the organization name provided above.</p>
        <ejs-uploader maxFileSize="5242880" name="UploadLogo" #defaultupload multiple="false"
          allowedExtensions=".jpg,.png" [autoUpload]="true" [dropArea]="dropEleLogo" [asyncSettings]="pathLogo"
          (uploading)="addHeaders($event)" (success)="onUploadSuccessLogo($event)"
          (failure)="onUploadFailureLogo($event)"
          ></ejs-uploader>
        <!-- <input name="UploadLogo" id="UploadLogo" type="file" data-role="upload" multiple="multiple" autocomplete="off"> -->
      </div>
      <div class="or">OR</div>
      <div class="organise">
        <h3 class="st-h3">Banner</h3>
        <p class="st-hint">Should include both your logo and organization name.</p>
        <ejs-uploader maxFileSize="5242880" name="UploadBanner" #defaultupload multiple="false"
          allowedExtensions=".jpg,.png" [autoUpload]="true" [dropArea]="dropEleBanner" [asyncSettings]="pathBanner"
          (uploading)="addHeaders($event)" (success)="onUploadSuccessBanner($event)"
          (failure)="onUploadFailureBanner($event)"></ejs-uploader>
      </div>
      <div class="st-actions st-actions--split">
        <button type="button" class="st-btn st-btn--ghost" (click)="closeOrg()">Cancel</button>
        <button type="button" class="st-btn st-btn--primary" (click)="UpdateOrgName()">Update</button>
      </div>
    </ejs-dialog>
  </div>

  <div #containerDisclaimer></div>

  <!-- TIP - Notebook Name Dialog -->
  <ejs-dialog #ejDialogNotebookName showCloseIcon="true" cssClass="fn-dialog fn-settings-form" header="Notebook Name" isModal="true"
    (overlayClick)="onOverlayClick()" width="400px" [visible]="false">
    <p>Display's the name of the notebook as set by the notebook owner.</p>
    <p class="notEditable">NOT EDITABLE</p>
  </ejs-dialog>


  <!-- TIP - Owner Name Dialog -->
  <ejs-dialog #ejDialogOwnerName showCloseIcon="true" cssClass="fn-dialog fn-settings-form" header="Notebook Owner Name" isModal="true"
    (overlayClick)="onOverlayClick()" width="400px" [visible]="false">
    <p>Display's the name of the Notebook Owner.</p>
    <p class="notEditable">NOT EDITABLE</p>
  </ejs-dialog>


  <!-- TIP - Dates Dialog -->
  <ejs-dialog #ejDialogDates showCloseIcon="true" cssClass="fn-dialog fn-settings-form" header="Notebook Dates" isModal="true"
    (overlayClick)="onOverlayClick()" width="400px" [visible]="false">
    <p>Display's the dates of the First and Last notes
      entered into the Notebook you print.</p>
    <p class="notEditable">NOT EDITABLE</p>
  </ejs-dialog>

  <!-- TIP - Timezone Dialog -->
  <ejs-dialog #ejDialogTimeZone showCloseIcon="true" cssClass="fn-dialog fn-settings-form" header="Timezone" isModal="true" (overlayClick)="onOverlayClick()"
    width="400px" [visible]="false">
    <p>Display's the Timezone as set by the user in the Profile Settings.</p>
  </ejs-dialog>
</div>